import { ChevronDown, ChevronUp, X } from "lucide-react";
import { Link } from "react-router";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle } from "@/components/ui/card";

export default function ClosableCard({
  children,
  title,
  className,
}: {
  children: React.ReactNode;
  title?: string;
  className?: string;
}) {
  const [isCollapsed, setIsCollapsed] = useState(false);

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle className="text-2xl font-bold">
          <div className="flex flex-row justify-between space-x-6 items-center">
            <div>{title}</div>
            <div className="flex gap-2">
              <Button
                variant="secondary"
                size="icon"
                onClick={() => setIsCollapsed(!isCollapsed)}
              >
                {isCollapsed ? <ChevronDown /> : <ChevronUp />}
              </Button>
              <Link to="/">
                <Button variant="secondary" size="icon">
                  <X />
                </Button>
              </Link>
            </div>
          </div>
        </CardTitle>
      </CardHeader>
      {!isCollapsed && children}
    </Card>
  );
}
